import React, { useState } from 'react';
import MaterialTable, { MTableToolbar } from "@material-table/core";

import './estilos.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons';

const Tabla = ({ columns, data, actions, title = '', CuentasFiltros = false, setFilteredData }) => {
    const tableRef = React.useRef();
    return (
        <MaterialTable
            tableRef={tableRef}
            columns={columns}
            data={data}
            title={title}
            actions={actions}
            localization={{
                body: {
                    emptyDataSourceMessage: 'No hay datos por mostrar',
                    addTooltip: 'Añadir',
                    deleteTooltip: 'Eliminar',
                    editTooltip: 'Editar',
                    filterRow: {
                        filterTooltip: 'Filtrar',
                    },
                    editRow: {
                        deleteText: '¿Segura(o) que quiere eliminar?',
                        cancelTooltip: 'Cancelar',
                        saveTooltip: 'Guardar',
                    },
                },
                grouping: {
                    placeholder: "Arrastre un encabezado aquí para agrupar",
                    groupedBy: 'Agrupado por',
                },
                header: {
                    actions: '',
                },
                pagination: {
                    firstAriaLabel: 'Primera página',
                    firstTooltip: 'Primera página',
                    labelRowsSelect: '{from}-{to} de {count}',
                    labelRowsPerPage: 'Filas por página:',
                    lastAriaLabel: 'Ultima página',
                    lastTooltip: 'Ultima página',
                    nextAriaLabel: 'Pagina siguiente',
                    nextTooltip: 'Pagina siguiente',
                    previousAriaLabel: 'Pagina anterior',
                    previousTooltip: 'Pagina anterior',
                    labelRows: 'filas'
                },
                toolbar: {
                    addRemoveColumns: 'Agregar o eliminar columnas',
                    exportAriaLabel: 'Exportar',
                    exportName: 'Exportar a CSV',
                    exportTitle: 'Exportar',
                    nRowsSelected: '{0} filas seleccionadas',
                    searchPlaceholder: 'Buscar',
                    searchTooltip: 'Buscar',
                    showColumnsAriaLabel: 'Mostrar columnas',
                    showColumnsTitle: 'Mostrar columnas',
                },
            }}
            onFilterChange={(appliedFilters) => {

                if (CuentasFiltros) {
                    let filtros = []
                    console.log('appliedFilters', appliedFilters)
                    appliedFilters.map(item => {
                        if (item.value.length > 0) {
                            filtros.push({ columna: item.column.field, value: item.value[0] })
                        }
                    })

                    setFilteredData(filtros)
                }

            }}
            components={{
                Pagination: (props) => {
                    const handleBackButtonClick = (event) => {
                        onPageChange(event, page - 1);
                    };

                    const handleNextButtonClick = (event) => {
                        onPageChange(event, page + 1);
                    };
                    const { page, rowsPerPage, count, onPageChange } = props
                    return (
                        <div className='row Paginacion'>
                            <div className='col-md-3 col-3'>
                                <button className='BtnPagina' onClick={handleBackButtonClick} disabled={page === 0}>
                                    <FontAwesomeIcon className='Rojovivo' icon={faChevronLeft} size="1x" />
                                </button>
                            </div>
                            <div className='col-md-6 col-6' style={{ textAlign: 'center' }}>
                                <p className='textPagina'><b>Página: {page + 1}</b> de {Math.ceil(count / rowsPerPage)}</p>
                            </div>
                            <div className='col-md-3 col-3' style={{ textAlign: 'right' }}>
                                <button className='BtnPagina' onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1}>
                                    <FontAwesomeIcon className='Rojovivo' icon={faChevronRight} size="1x" />
                                </button>
                            </div>
                        </div>
                    )
                },
                /*Toolbar: (props) => {
                    console.log(props)
                    const [buscar, setBuscar] = useState(false)
                    return (
                        <div style={{ padding: '10px', display: 'flex', alignItems: 'center' }}>
                            {
                                buscar ?
                                    <div>
                                        <button
                                            onClick={e => { setBuscar(false); }}
                                            className="btn boton_estandar btn-lg derecha">
                                            <FontAwesomeIcon icon={faXmark} />

                                        </button>

                                        <div style={{ float: 'right' }}>
                                            <div className='Buscador'>

                                                <span><FontAwesomeIcon icon={faMagnifyingGlass} style={{ marginTop: 7, color: '#ccc' }} /></span>
                                                <input className="inputBuscador" type="text" name="descripcion" required style={{ float: 'right', paddingLeft: 10, paddingTop: 3 }}
                                                    //value={busqueda}
                                                    onChange={(event) => props.searchText = 'gabriel'}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    :
                                    <button
                                        onClick={e => setBuscar(true)}
                                        className="btn boton_estandar btn-lg derecha">
                                        <FontAwesomeIcon icon={faMagnifyingGlass} />
                                    </button>
                            }

                        </div >
                    )
                },*/
            }}

            options={{
                filtering: true,
                sorting: true,
                exportButton: false, // Mostrar el botón de exportación
                exportAllData: false, // Exportar todos los datos (o solo los filtrados)
                idSynonym: 'unique_parent_id',
                cellStyle: { border: '1px solid #eee' },
                actionsColumnIndex: -1,
                paginationType: "stepped",
                pageSize: data.length <= 5 ? 5 : data.length <= 10 ? 10 : 20,

                maxColumnSort: true,
                thirdSortClick: false,
                search: true,
                paging: true,
                paginationPosition: "top"
            }}
        />
    )
}

export default Tabla